module.exports = __webpack_public_path__ + "static/media/map_selected.9d7d036f.svg";